import { AbstractControlOptions, FormArray, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import {
  PledgeRead,
  Parameters,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import { isFieldRequired } from '@app/forms/subscription/services/utile';
import { CompanyFieldType } from '@app/forms/subscription/definition/interface/enum';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generate(entity: PledgeRead) {
    const parameters: Parameters = {
      ...entity?.parameters,
    };
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<{
      hasMadeMoreThanFiveIndirectRealEstateTransactionsLastYear: boolean;
      isInvestmentOver25KIndirectRealEstateLastYear: boolean;
    }> = {
      hasMadeMoreThanFiveIndirectRealEstateTransactionsLastYear: [
        parameters?.hasMadeMoreThanFiveIndirectRealEstateTransactionsLastYear ||
          null,
        isFieldRequired(
          parameters,
          CompanyFieldType.INDIRECT_REAL_ESTATE_PRODUCTS_TRANSACTIONS,
        )
          ? Validators.required
          : Validators.nullValidator,
      ],
      isInvestmentOver25KIndirectRealEstateLastYear: [
        parameters?.isInvestmentOver25KIndirectRealEstateLastYear || null,
        isFieldRequired(
          parameters,
          CompanyFieldType.INDIRECT_REAL_ESTATE_PRODUCTS_TRANSACTIONS,
        )
          ? Validators.required
          : Validators.nullValidator,
      ],
    };
    return this.formBuilder.group(formConfig, options);
  }

  get owners() {
    return this.form.get('owners') as FormArray;
  }

  extract() {
    return { ...this.form.value };
  }
}
